var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column1-container"},[_c('div',{staticClass:"title"},[_vm._v("遂宁市物流大数据")]),_c('div',{staticClass:"output-value"},[_vm._v(" "+_vm._s(_vm.year)+"年物流总产值 "),_c('span',[_c('dv-digital-flop',{staticStyle:{"width":"310px","height":"75px"},attrs:{"config":{
        number: [Number(_vm.count)],
        toFixed: 2,
        style: _vm.line1Style,
        animationCurve: 'easeOutCubic',
        animationFrame: 100
      }}})],1),_vm._v("亿元 ")]),_c('bar-chart-1'),_c('bar-chart-2')],1)}
var staticRenderFns = []

export { render, staticRenderFns }